import React from "react";
import Nav from "../components/Nav";
import Circles from "../components/Circles";

function Gdpr({noNav}) {
  return (
    <section className="bg-petrol-500">
      {!noNav && <Nav />}
      <div className="container text">
        <h1 className="mb-8 self-center">GDPR</h1>
        <p className="mb-4">
          De kategorier av personuppgifter som kommer att behandlas är ditt
          namn, ditt telefonnummer och din mailadress. Genom att acceptera
          tävlingsvillkoren godkänner du att de uppgifter du lämnar om dig själv
          i samband med insändande av bidrag kommer att behandlas för att kunna
          administrera tävlingen samt för kommunikation med dig under
          Quiz-kampanjens period. I samband med publicering av vinnare av
          tävlingen kommer personuppgifter som namn att publiceras på Frölunda
          Torgs sociala kanaler och hemsida samt på quizets topplista. Efter
          avslutad tävling, och när priserna har delats ut till vinnarna, kommer
          personuppgifter som samlats in om de tävlande att raderas.
        </p>
        <p className="mb-4">Personuppgifterna behandlas i enlighet med GDPR.</p>
      </div>
     
    </section>
  );
}

export default Gdpr;
